import { CreateAxiosDefaults } from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    /** 로그인이 풀려 있어도 세션 만료 안내를 띄우지 않는다 (앱 시작 때 로그인 확인처럼) */
    silentAuthError?: boolean;
  }
}

const { REACT_APP_API_URL, REACT_APP_TIMEOUT } = process.env;

/**
 * Axios 인스턴스 기본 설정
 */
export const DEFAULT_AXIOS_CONFIG: CreateAxiosDefaults = {
  baseURL: REACT_APP_API_URL,
  withCredentials: true,
  timeout: REACT_APP_TIMEOUT ? parseInt(REACT_APP_TIMEOUT) : 3000,
};
